export enum ContractStatus {
  InProgress = 'in_progress',
  Archived = 'archived',
  Voided = 'voided',
  Suspended = 'suspended',
  Refunded = 'voided',
  Terminated = 'terminated',
  Cancelled = 'cancelled',
  Closed = 'closed',
  Invalidated = 'invalidated',
  Processed = 'processed',
  Covered = 'covered',
  WaitingForSignature = 'waiting_for_signature',
  WaitingForDetails = 'waiting_for_details',
  WaitingForDetailsAndVerification = 'waiting_for_details_and_verification',
  WaitingForValidation = 'waiting_for_validation',
  WaitingForValidationAndVerification = 'waiting_for_validation_and_verification',
  WaitingForVerification = 'waiting_for_verification',
  WaitingForConfirmation = 'waiting_for_confirmation',
  WaitingForPayment = 'waiting_for_payment'
}

export const ArchivedContractStatuses = [
  ContractStatus.Archived,
  ContractStatus.Closed,
  ContractStatus.Voided,
  ContractStatus.Terminated,
  ContractStatus.Refunded,
  ContractStatus.Suspended,
  ContractStatus.Invalidated
]

export const InProgressContractStatuses = [ContractStatus.InProgress, ContractStatus.Processed]

export const PendingContractStatuses = [
  ContractStatus.WaitingForPayment,
  ContractStatus.WaitingForConfirmation,
  ContractStatus.WaitingForVerification,
  ContractStatus.WaitingForValidationAndVerification,
  ContractStatus.WaitingForValidation,
  ContractStatus.WaitingForDetailsAndVerification,
  ContractStatus.WaitingForDetails,
  ContractStatus.WaitingForSignature
]

export enum Status {
  InProgress = 'in_progress',
  Pending = 'pending',
  Archived = 'archived'
}
